export const fstJids = [
  'Barbados',
  'California (Fremont)',
  'California (Fresno)',
  'California (Chatsworth)',
  'California (Sacramento)',
  'California (San Bernardino)',
  'California (San Diego)',
  'California (Santa Fe Springs)',
  'Colorado',
  'Connecticut',
  'Florida (Cape Coral)',
  'Florida (Miami)',
  'Florida (Orlando)',
  'Florida (Pensacola)',
  'Florida (Tallahassee)',
  'Florida (Tampa)',
  'Georgia',
  'Indiana (North)',
  'Indiana (Office)',
  'Indiana (South)',
  'Kentucky',
  'Massachusetts',
  'Michigan (Wixom)',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'New York (Bronx)',
  'New York (Islandia)',
  'New York (Latham)',
  'New York (Rochester)',
  'New York (Saugerties)',
  'North Carolina',
  'Oregon',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas (Central)',
  'Texas (North)',
  'Texas (Southeast)',
  'Texas (Southwest)',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
];

export const reasons = [
  'Administrative',
  'Depot Coverage',
  'Depot Repair',
  'Down Call',
  'Drive Home',
  'High Jackpots',
  'Holiday Coverage',
  'Urgent Removal Request - Ad-hoc',
  'Lottery Special Events',
  'NOC Repoints /ASI Calls',
  'On-Site / Off-site Meeting',
  'Other',
  'Out-of-State Project',
  'Phone Support (On-call assist)',
  'Penalty Call',
  'Project (other)',
  'Site Project',
  'Software Issues',
  'Staffing / Field Coverage',
  'Standby / Service Call Coverage',
  'Training',
  'Travel',
  'Vacation Coverage',
  'Vehicle Issues / Breakdowns',
  'Weather-related',
];
